import { isIOS, isNative } from "@/lib/platform";
import type { DeviceIdGenerator } from "../types";

export class WebDeviceIdGenerator implements DeviceIdGenerator {
  async generate(): Promise<string> {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    ctx?.fillText("device-id", 10, 10);
    const canvasFingerprint = canvas.toDataURL();

    const userAgent = navigator.userAgent;
    const screen = `${window.screen.width}x${window.screen.height}`;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const deviceFingerprint = `${userAgent}-${screen}-${timezone}-${canvasFingerprint}`;

    let hash = 0;
    for (let i = 0; i < deviceFingerprint.length; i++) {
      const char = deviceFingerprint.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }

    return `web-${Math.abs(hash).toString(36)}`;
  }
}

export class NativeDeviceIdGenerator implements DeviceIdGenerator {
  async generate(): Promise<string> {
    try {
      if ((window as any).Capacitor) {
        const platform = (window as any).Capacitor.getPlatform();
        return `${platform}-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
      }
    } catch (error) {
      console.warn("Failed to get Capacitor device info:", error);
    }

    const platform = isIOS() ? "ios" : "android";
    return `${platform}-${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
  }
}

export const createDeviceIdGenerator = (): DeviceIdGenerator => {
  return isNative() ? new NativeDeviceIdGenerator() : new WebDeviceIdGenerator();
};
